module.exports = __webpack_public_path__ + "static/media/publishing_image1.fca6bf46.webp";